export enum ContentTypeValue {
    PDF = 'application/pdf',
    OCTET_STREAM = 'application/octet-stream'
}

export enum RecipientsType {
  NORMAL = 'NORMAL',
  CC = 'CC',
  CCO = 'CCO'
}

export enum DistributionListKey {
  COMPLAINT_WITH_INSPECTION = 'DENUNCIA_AUTOS_IN',
  COMPLAINT_WITHOUT_INSPECTION = 'DENUNCIA_AUTOS',
  COMPLAINT_WITH_VOUCHER_CRYSTALS = 'DENU_AUT_VOUCHER_CRI',
  COMPLAINT_WITH_VOUCHER_WHEELS = 'DENU_AUT_VOUCHER_RUE',
  COMPLAINT_RV = 'DENUNCIA_RV',
  AP_RENEW = 'RENOVACION_AP',
  ET_INSURED = 'AYBNOMINA',
  MARKETING_CONTACT = 'LISTA_MARKETING',
}

export enum MESSAGES_SENDMAIL {
  ERROR_MESSAGE = '¡Ocurrió un error inesperado! Envío automático de correo electrónico fallido.',
  SUCCESS_MESSAGE_MKT = 'Gracias por contactarnos, nos estaremos comunicando con vos en breve.',
}

export interface MailConfiguration {
  subject: string;
  destinatarios: Recipients[]
}

export interface Recipients {
  to?: string;
  toAddress: string;
  toType: string;
}

export interface RecipientsMap {
  to: string;
  cc: string;
  cco: string;
}

export interface SendMailRequest {
    message: {
      subject: string;
      body: {
        contentType: "Text" | "HTML";
        content: string;
      };
      toRecipients: {
        emailAddress: {
          address: string;
        };
      }[];
      ccRecipients?: {
        emailAddress: {
          address: string;
        };
      }[];
      bccRecipients?: {
        emailAddress: {
          address: string;
        };
      }[];
      attachments?: {
        "@odata.type": "#microsoft.graph.fileAttachment";
        name: string;
        contentType: string;
        contentBytes: string;
      }[];
    };
    saveToSentItems?: boolean;
}

export interface BaseParams {
    subject?: string;
    body?: string;
    contentType?: "Text" | "HTML";
    includeAttachments?: boolean;
    saveToSentItems?: boolean;
  }
  
  export interface AttachmentParams {
    attachmentBase64: string;
    attachmentName?: string;
    attachmentMimeType?: string;
  }

  export type BuildSendMailParams = BaseParams & Partial<AttachmentParams>;
